import { Modals } from '@/constants';
import { appStyles } from '@/theme';

import { AppModal } from '../AppModal';
import { EpisodeEvaluationModalContent } from './EpisodeEvaluationModalContent';

export const EpisodeEvaluationModal = () => {
  return (
    <AppModal
      modalName={Modals.EPISODE_EVALUATION}
      sx={appStyles.scrollbar}
      transparentBackground
      scroll="paper">
      <EpisodeEvaluationModalContent />
    </AppModal>
  );
};
